import { CalendarInputComponent } from './controls/calendar-input/calendar-input.component';
import { FileInputComponent } from './controls/file-input/file-input.component';

export const allComponents = [CalendarInputComponent, FileInputComponent];
export const publicComponents = [CalendarInputComponent, FileInputComponent];

export * from './controls';
